import { useEffect } from 'react';

import { IconType } from '@components/Icon';
import { translate } from '@chaika/i18n/helper';
import { store } from '@store';
import { HeaderComponents } from '@core/Page/Header/types';

export function useHeaderMenu() {
    const { app } = store;
    const pageTitle = translate('accounting');

    useEffect(() => {
        app.headerView.setHeaderView({
            center: {
                component: HeaderComponents.CenterTabNavigation,
                props: { text: pageTitle, icon: IconType.ACCOUNTING },
            },
            bottom: {
                component: HeaderComponents.NavigationTab,
            },
        });
        app.greyBackground = true;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
